import React from 'react';
import { MDBCard, MDBCardBody } from 'mdb-react-ui-kit';

const LaborSavings = () => {
  const savingsData = {
    manual: [45, 52, 38, 61, 48, 55, 42, 58, 44, 50, 46, 53],
    automated: [12, 15, 10, 18, 14, 16, 11, 17, 13, 15, 12, 16],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  };

  const maxValue = Math.max(...savingsData.manual, ...savingsData.automated);
  const totalSavings = savingsData.manual.reduce((sum, val, i) => sum + (val - savingsData.automated[i]), 0);

  return (
    <MDBCard className="dashboard-card savings-card">
      <MDBCardBody>
        <div className="card-header">
          <h3 className="card-title">Automation & Labor Savings</h3>
          <p className="card-subtitle">Manual vs Automated listing hours</p>
        </div>
        
        <div className="savings-metrics">
          <div className="metric">
            <div className="metric-value">{totalSavings}h</div>
            <div className="metric-label">Hours Saved</div>
          </div>
          <div className="metric">
            <div className="metric-value">73%</div>
            <div className="metric-label">Efficiency Gain</div>
          </div>
          <div className="metric">
            <div className="metric-value">$4,680</div>
            <div className="metric-label">Cost Savings</div>
          </div>
        </div>
        
        <div className="area-chart">
          <div className="chart-grid">
            {savingsData.months.map((month, index) => (
              <div key={month} className="chart-column">
                <div className="bars-container">
                  <div 
                    className="manual-bar"
                    style={{
                      height: `${(savingsData.manual[index] / maxValue) * 100}%`,
                      animationDelay: `${index * 0.1}s`
                    }}
                    data-tooltip={`Manual: ${savingsData.manual[index]}h`}
                  ></div>
                  <div 
                    className="automated-bar"
                    style={{
                      height: `${(savingsData.automated[index] / maxValue) * 100}%`,
                      animationDelay: `${index * 0.1 + 0.05}s`
                    }}
                    data-tooltip={`Automated: ${savingsData.automated[index]}h`}
                  ></div>
                </div>
                <div className="month-label">{month}</div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="chart-legend">
          <div className="legend-item">
            <div className="legend-color manual"></div>
            <span>Manual Listing</span>
          </div>
          <div className="legend-item">
            <div className="legend-color automated"></div>
            <span>Automated Listing</span>
          </div>
        </div>
      </MDBCardBody>
    </MDBCard>
  );
};

export default LaborSavings;